import _isNil from 'lodash/isNil';
import _isFunction from 'lodash/isFunction';

var logApiDebugInfoToPuppeteer = function logApiDebugInfoToPuppeteer(response, message) {
  var _response$request, _response$headers;

  if (!_isFunction(window.logMsgAtPuppeteer)) {
    return;
  }

  var msgPrefix = !_isNil(message) ? "Message: ".concat(message, " | ") : '';
  var msgToLog = "".concat(msgPrefix, "Response URL: ").concat(response === null || response === void 0 ? void 0 : (_response$request = response.request) === null || _response$request === void 0 ? void 0 : _response$request.responseURL, " | Time Taken: ").concat(response === null || response === void 0 ? void 0 : response.duration, " | TraceID: ").concat(response === null || response === void 0 ? void 0 : (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.traceid);
  window.logMsgAtPuppeteer(msgToLog);
};

var logApiErrorInfoToPuppeteer = function logApiErrorInfoToPuppeteer(response) {
  var _response$data, _response$data$errorD, _response$headers2, _response$headers3;

  if (!_isFunction(window.logMsgAtPuppeteer)) {
    return;
  }

  var errorMessage = "API Error - Message: ".concat(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$errorD = _response$data.errorDetails) === null || _response$data$errorD === void 0 ? void 0 : _response$data$errorD.debugMessage, " | Request URL: ").concat(response === null || response === void 0 ? void 0 : (_response$headers2 = response.headers) === null || _response$headers2 === void 0 ? void 0 : _response$headers2.requesturl, " | TraceID: ").concat(response === null || response === void 0 ? void 0 : (_response$headers3 = response.headers) === null || _response$headers3 === void 0 ? void 0 : _response$headers3.traceid);
  window.logMsgAtPuppeteer(errorMessage);
};

export { logApiDebugInfoToPuppeteer, logApiErrorInfoToPuppeteer };